<script setup lang="ts">
import { useTranslation } from 'i18next-vue';
import ConfirmationModal from './ConfirmationModal.vue';
import { confirmationInjectionKeys } from './types';
import { getDefaultOptions } from './defaults';
import { computed } from 'vue';

const { t } = useTranslation();

const defaultOptions = computed(() => getDefaultOptions(t));
</script>

<template>
  <ConfirmationModal
    :defaultOptions="defaultOptions"
    :injectionKey="confirmationInjectionKeys.form"
  >
    <slot />
  </ConfirmationModal>
</template>
